import { imageSize } from 'image-size';

const loadAsBlob = async (url: string) => await (await fetch(url)).blob();

const blobToArrayBuffer = (blob: Blob) => new Promise<ArrayBuffer>((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => resolve(reader.result as ArrayBuffer);

    reader.onerror = event => reject(event);

    reader.readAsArrayBuffer(blob);
});

const headers = {
    png: [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a],
    jpg: [0xff, 0xd8, 0xff]
};

const checkHeaders = (buffers, headers, options = { offset: 0 }) => headers.every((header, index) => header === buffers[options.offset + index]);

const getType = async (blob: File | Blob) => {
    try {
        const uint8Array = new Uint8Array(await blobToArrayBuffer(blob.slice(0, 8)));

        if (checkHeaders(uint8Array, headers.jpg))
            return 'image/jpeg';

        if (checkHeaders(uint8Array, headers.png))
            return 'image/png';
    } catch (_) {}

    if (blob.type)
        return blob.type;

    if (blob instanceof File) {
        const fileName = blob.name.toLowerCase();

        if (fileName.endsWith('.mp3'))
            return 'audio/mpeg';
    }

    return null;
};

const isImageType = async (blob: Blob) => (await getType(blob))?.startsWith('image/') ?? false;

// Maximum input size, with a default of 512 kilobytes (512 * 1024 = 524288).
const getImageSizes = async (blob: Blob) => {
    try {
        const { width, height } = imageSize(new Uint8Array(await blobToArrayBuffer(blob.slice(0, 524288))));

        return width && height ? { width, height } : undefined;
    } catch (_) {
        return undefined;
    }
};

const files = { loadAsBlob, blobToArrayBuffer, getType, isImageType, getImageSizes };

export default files;
